import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const PreviewModal = ({ show, onHide, previewMedia, initialIndex = 0 }) => {
    const [activeIndex, setActiveIndex] = useState(initialIndex);

    const isArray = Array.isArray(previewMedia);
    const mediaArray = isArray ? previewMedia : (previewMedia ? [previewMedia] : []);

    useEffect(() => {
        if (show) {
            setActiveIndex(isArray ? initialIndex : 0);
        }
    }, [show, initialIndex, isArray]);

    const activeMedia = mediaArray[activeIndex] || null;

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            contentClassName="bg-transparent border-0 shadow-none"
            backdrop="static"
            style={{ backdropFilter: 'blur(8px)', backgroundColor: 'rgba(0,0,0,0.8)' }}
        >
            <Modal.Header closeButton closeVariant="white" className="border-0 pb-3 px-3">
                <Modal.Title className="text-white h6 mb-0 d-flex align-items-center gap-2">
                    {activeMedia?.title && <span className="bg-white bg-opacity-10 px-2 py-1 rounded-2">{activeMedia.title}</span>}
                    {activeMedia?.type === 'document' && (
                        <a
                            href={activeMedia.url}
                            download
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-outline-light py-0 px-2 border-0"
                            title="Download"
                        >
                            <small>⬇ Download</small>
                        </a>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 text-center">
                {isArray ? (
                    mediaArray.length > 0 && (
                        <Swiper
                            modules={[Navigation]}
                            navigation
                            initialSlide={initialIndex}
                            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                            className="w-100 h-100"
                        >
                            {mediaArray.map((media, index) => (
                                <SwiperSlide key={index} className="d-flex align-items-center justify-content-center">
                                    {media.type === 'video' ? (
                                        <video
                                            src={media.url}
                                            controls
                                            autoPlay={index === activeIndex}
                                            className="w-100 rounded-3 shadow-lg"
                                            style={{ maxHeight: '80vh' }}
                                        />
                                    ) : media.type === 'image' ? (
                                        <img
                                            src={media.url}
                                            alt="Preview"
                                            className="mw-100 rounded-3 shadow-lg"
                                            style={{ maxHeight: '80vh', objectFit: 'contain' }}
                                        />
                                    ) : (
                                        <div className="bg-white rounded-3 overflow-hidden w-100" style={{ height: '80vh' }}>
                                            <iframe
                                                src={media?.url}
                                                title="Document Preview"
                                                className="w-100 h-100 border-0"
                                            />
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )
                ) : (
                    activeMedia && (
                        <div className="d-flex align-items-center justify-content-center w-100">
                            {activeMedia.type === 'video' ? (
                                <video
                                    src={activeMedia.url}
                                    controls
                                    autoPlay
                                    className="w-100 rounded-3 shadow-lg"
                                    style={{ maxHeight: '80vh' }}
                                />
                            ) : activeMedia.type === 'image' ? (
                                <img
                                    src={activeMedia.url}
                                    alt="Preview"
                                    className="mw-100 rounded-3 shadow-lg"
                                    style={{ maxHeight: '80vh', objectFit: 'contain' }}
                                />
                            ) : (
                                <div className="bg-white rounded-3 overflow-hidden w-100" style={{ height: '80vh' }}>
                                    <iframe
                                        src={activeMedia.url}
                                        title="Document Preview"
                                        className="w-100 h-100 border-0"
                                    />
                                </div>
                            )}
                        </div>
                    )
                )}
            </Modal.Body>
        </Modal>
    );
};

export default PreviewModal;